export default __webpack_public_path__ + "static/media/Vector.0fc611ef.svg";